import API from 'utils/api';
import { onError } from 'utils/handlers';
import { message } from 'antd';

export const consultaRepuveNacionalFieldMap = {
  numero_de_identificacion_vehicular: 'niv',
  numero_de_placa_vigente: 'placa',
};

/**
 * POST Consulta REPUVE nacional
 * @param {object} values
 * @param {number} values.numero_de_identificacion_vehicular
 * @param {number} values.numero_de_placa_vigente
 * @returns {Promise<object|null|false>} object=vehiculo o errores relacionados al mismo |
 *    null=servicio no disponible | false=vehiculo no registrado
 */
export const postConsultaRepuveNacional = async (_values) => {
  try {
    const values = Object.fromEntries(Object.keys(consultaRepuveNacionalFieldMap)
      .map((k) => [consultaRepuveNacionalFieldMap[k], _values[k]]).filter((e) => e[1]));
    const response = await API.post('recaudacion/consulta-repuve/', values);
    const object = Object.fromEntries(
      response.data.split('\n').map((e) => e.trim()).filter(([first]) => first === '[')
        .map((e) => e.split('=>').map((c) => c.trim().replace('[', '').replace(']', ''))),
    );
    object.paramsConsulta = values;
    // NO se encontro en webservice
    if (/error 402/i.test(object.Error_Descripcion)) {
      message.info('El vehículo ingresado No existe en la Base de Datos Nacional');
      return false;
    }
    // error interno en base de datos nacional
    if (/error interno|no disponible/i.test(object.Error_Descripcion)) {
      message.info(object.Error_Descripcion, 10);
      return null;
    }

    // validando reporte de robo
    object.reporteRobo = /robo/i.test(object.Error_Descripcion) || !!object.doConsRepRobo_Id_estatus;
    if (object.reporteRobo) {
      object.Error_Descripcion = 'No se puede continuar con el trámite ya que el vehículo tiene reporte de Robo';
    }

    // normalizando valores
    object.doConsRpv_Pedimento = object.doConsRpv_Pedimento === '0'
      ? null : object.doConsRpv_Pedimento;
    object.doConsRpv_Clave_importador = object.doConsRpv_Clave_importador === '0'
      ? null : object.doConsRpv_Clave_importador;
    object.doConsRpv_procedencia = object.doConsRpv_Pedimento ? 'EXTRANJERO' : 'NACIONAL';
    // Si existe algun error se muestra
    if (object.Error_Descripcion) {
      message.info(object.Error_Descripcion, 10);
    } else if (!object.reporteRobo) {
      message.info('Vehículo No Cuenta con reporte de Robo', 10);
    }
    return object;
  } catch (err) {
    onError(err);
  }
  // web service o backend NO disponible
  message.info('No pudo realizarse consulta a la Base de Datos Nacional');
  return null;
};

/**
 * POST Reintentar enviar informacion a WS REPUVE nacional
 * @param {number} tramite
 * @returns Promise<object|boolean>
 */
export const postEnviarInformacionWS = async (tramite, msg) => {
  try {
    const response = await API.post('tramites/tramites-repuve/inscripcion/', { tramite });
    message.info('Información enviada a Base de datos nacional');
    return response.data;
  } catch (err) {
    message.warn(msg);
    onError(err);
  }
  return false;
};

/**
 * POST Masivo reintentar enviar informacion a WS REPUVE nacional
 * @returns Promise<boolean>
 */
export const postMasivoEnviarInformacionWS = async () => {
  try {
    await API.get('tramites/tramites-repuve/inscripcion-masiva/');
    message.info('Se intentará enviar información a Base de datos nacional, recibirá una notificación por correo electrónico con los resultados');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};
